import { useState } from "react";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const loginResult = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );

      const userId = loginResult.user.uid;
      const adminReference = doc(db, "admins", userId);
      const adminSnapshot = await getDoc(adminReference);

      if (!adminSnapshot.exists()) {
        await signOut(auth);
        setMessage("This account does not have admin access.");
        return;
      }

      const adminData = adminSnapshot.data();

      if (adminData.role !== "admin") {
        await signOut(auth);
        setMessage("This account does not have admin access.");
        return;
      }

      navigate("/admin-dashboard");
    } catch (error) {
      console.error("Admin login error:", error);

      if (
        error.code === "auth/invalid-credential" ||
        error.code === "auth/wrong-password" ||
        error.code === "auth/user-not-found"
      ) {
        setMessage("Incorrect email address or password.");
      } else if (error.code === "auth/too-many-requests") {
        setMessage("Too many login attempts. Please try again later.");
      } else if (error.code === "auth/network-request-failed") {
        setMessage("Internet connection problem. Please try again.");
      } else {
        setMessage("Unable to log in. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <div className="brand-mark">TW</div>

          <div>
            <h1>Trading Wealth CRM</h1>
            <p>Admin Portal</p>
          </div>
        </div>

        <div className="admin-login-heading">
          <h2>Welcome back</h2>
          <p>Sign in to manage employees, leads and performance.</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="admin-email">Email address</label>

            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Enter your admin email"
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="admin-password">Password</label>

            <div className="password-field">
              <input
                id="admin-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
                required
              />

              <button
                type="button"
                className="show-password-button"
                onClick={() => setShowPassword((currentValue) => !currentValue)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {message && <div className="login-message">{message}</div>}

          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in as Admin"}
          </button>
        </form>

        <button
          type="button"
          className="employee-admin-login-link"
          onClick={() => navigate("/employee-login")}
        >
          Go to Employee Login
        </button>

        <p className="admin-login-footer">
          Authorized Trading Wealth administrators only
        </p>
      </div>
    </div>
  );
}

export default AdminLogin;